import { connect } from "react-redux";
import Popoto3dLogo from "../components/Popoto3dLogo";

export default connect(
  (state, props) => ({}),
  (dispatch, props) => ({})
)(Popoto3dLogo);
